import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-059607a4")

_pushScopeId("data-v-059607a4")
const _hoisted_1 = { class: "px-5 system-error flex justify-center items-center relative px-5" }
const _hoisted_2 = { class: "system-error__wrapper flex flex-column justify-center items-center" }
const _hoisted_3 = { class: "system-header my-5" }
const _hoisted_4 = { class: "system_desc" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.systemError,
        alt: ""
      }, null, 8, ["src"]),
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.t('500.textHeaderSystem')), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.t('500.descSystem')), 1)
    ])
  ]))
})